<ng-container>
  <cwc-radio-group [value]="ContractType.Contract" [name]="'contract-type'" designVersion="v2">
    <cwc-radio
      *ngIf="availableInvoiceDocuments?.length > 0"
      [attr.data-tid]="ContractType.Contract"
      (cwcClick)="selectContractType(ContractType.Contract)"
      [value]="ContractType.Contract"
      designVersion="v2"
    >
      {{ 'views.one_click.contract' | translate }}
    </cwc-radio>
    <cwc-radio
      *ngIf="availableInvoiceDocuments?.length > 0"
      [attr.data-tid]="ContractType.Invoice"
      (cwcClick)="selectContractType(ContractType.Invoice)"
      [value]="ContractType.Invoice"
      designVersion="v2"
    >
      {{ 'views.one_click.invoice' | translate }}
    </cwc-radio>
  </cwc-radio-group>
</ng-container>

<!-- Display regular contract selection -->
<ng-container *ngIf="contractTypeSelected === ContractType.Contract">
  <div class="row mt-2">
    <div class="col-md-6">
      <div class="retail-control" [formGroup]="group">
        <cwc-picker
          [label]="'views.one_click.contract' | translate"
          [formControlName]="config.name"
          (cwcChange)="contractChanged($event.detail)"
          [disabled]="config.disabled"
          designVersion="v2"
        >
          <cwc-picker-option *ngFor="let option of availableContracts" [value]="option.id" designVersion="v2">
            {{ option.name }}
          </cwc-picker-option>
        </cwc-picker>
      </div>
    </div>
  </div>
</ng-container>

<!-- Display invoice selection -->
<ng-container *ngIf="contractTypeSelected === ContractType.Invoice">
  <div class="row mt-2">
    <div class="col-md-6">
      <div class="retail-control" [formGroup]="group">
        <cwc-picker
          [label]="'views.one_click.invoice' | translate"
          [formControlName]="config.name"
          (cwcChange)="invoiceDocumentChanged($event.detail)"
          [disabled]="config.disabled"
          designVersion="v2"
        >
          <cwc-picker-option *ngFor="let document of availableInvoiceDocuments" [value]="document" designVersion="v2">
            {{ document['name'] }}
          </cwc-picker-option>
        </cwc-picker>
      </div>
    </div>
    <div *ngIf="selectedInvoiceDocument" class="col-md-6 invoice-def">
      <div [attr.data-test]="config.name">
        <div class="field input flex-space-between">
          <div class="progress-bar"><span [style.width]="labels?.balance + '%'"></span></div>
          <span class="invoice-balance">{{ labels?.remaining }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
